export default "__VITE_ASSET__JeOdJCR$__";